import script from "./FamilyTreeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyTreeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyTreeComponent.vue?vue&type=style&index=0&id=68828050&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68828050"]])

export default __exports__